import React from "react";
import { addSignatures, uploadImg } from "@/api/message";
import { b64toBlob } from "@/utils/format";
import { getQueryString } from "@/utils/tools";
import { Upload, Icon, message, Select, Input, Button, Modal } from "antd";
import "./style.less";

const Option = Select.Option;
const professionSelect = [
  "游戏",
  "移动应用",
  "视频",
  "IT/通信/电子服务",
  "电子商务",
  "金融",
  "网站",
  "商业服务",
  "房地产/建筑",
  "零售/租赁/贸易",
  "生产/加工/制造",
  "交通/物流",
  "文化传媒",
  "能源/电气",
  "政府企业",
  "农业",
  "物联网",
  "其他"
];
const fileSelect = [
  "公司营业执照（签名是公司名称）",
  "委托授权书或对方营业执照（签名涉及第三方公司）"
];
const clsPrefix = "addSignature";

class AddSignature extends React.Component {
  constructor() {
    super();
    this.state = {
      accountAttribute: 1,
      previewVisible: false,
      previewImage: "",
      fileList: [],
      imgUrl: null,
      signature: undefined,
      profession: null,
      loading: false,
    };
  }
  
  /*  上传图片*/
  beforeUpload = file => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("照片大小必须小于5MB!");
    }
    return true;
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = file => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true
    });
  };

  handleUpload = ({ fileList }) => {
    this.setState({ fileList });
    if (fileList.length > 0) {
      if (fileList[0].status !== "uploading") {
        this.setState({
          loading: true
        })
        setTimeout(() => {
          const blob = b64toBlob(fileList[0].thumbUrl);
          const siteId = getQueryString("siteId");
          uploadImg(siteId, blob)
            .then(res => {
              const { url_origin } = res.data.data;
              this.setState({
                imgUrl: url_origin,
                fileList,
                loading: false
              });
            })
            .catch(error => {
              message.error("图片上传失败,请重新上传");
            });
        }, 2000);
      }
    }
  };

  handleRemove = () => {
    this.setState({
      flieList: [],
      imgUrl: null
    });
  };

  /* select下拉框 */
  handleSelect = (type, value) => {
    this.setState({
      [type]: value
    });
  };

  /* input输入框 */
  handleChange = (type, e) => {
    this.setState({
      [type]: e.target.value
    });
  };

  handleSubmit = () => {
    const { signature, profession, imgUrl } = this.state;
    this.setState({
      loading: true
    });
    addSignatures(
      signature,
      profession,
      imgUrl
    ).then(() => {
      this.setState({
        loading: false
      })
    });
  }

  /* 验证签名格式 */
  testSignature = e => {
    const { value } = e.target;
    if (
      /^[\u4e00-\u9fa5a-zA-Z]{3,8}$/.test(value) &&
      !/^[a-zA-Z]$/.test(value)
    ) {
      return true;
    } else {
      message.warning("格式错误，请输入3到8个字的中英文(不能存在空格)");
      e.target.value = "";
    }
  };

  render() {
    const { previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">点击选择图片</div>
      </div>
    );
    return (
      <div className={`${clsPrefix}`}>
        <h2>新增签名</h2>
        <div className={`${clsPrefix}-formBox`}>
          <div className={`${clsPrefix}-item`}>
            <span>短信签名: </span>
            <Input
              onChange={e => this.handleChange("signature", e)}
              onBlur={this.testSignature}
              style={{ display: "inline-block", width: 380 }}
              placeholder="请填写公司的产品/网站/公司名(3-8个字的中英文的组合)"
            />
          </div>
          <div className={`${clsPrefix}-item`}>
            <span>所属行业: </span>
            <Select
              onChange={value => this.handleSelect("profession", value)}
              showSearch
              style={{ width: 200 }}
              placeholder="请选择所属行业"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {professionSelect.map((item, key) => (
                <Option value={item} key={key}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
          <div className={`${clsPrefix}-item`}>
            <span>证明文件: </span>
            <Select
              showSearch
              style={{ width: 420 }}
              placeholder="请选择证明文件"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {fileSelect.map((item, key) => (
                <Option value={item} key={key}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
          <div className={`${clsPrefix}-item`}>
            <span>上传证明: </span>
            <div className={`${clsPrefix}-upload`}>
              <Upload
                listType="picture-card"
                fileList={fileList}
                beforeUpload={this.beforeUpload}
                onPreview={this.handlePreview}
                onChange={this.handleUpload}
                onRemove={this.handleRemove}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal
                visible={previewVisible}
                footer={null}
                onCancel={this.handleCancel}
              >
                <img
                  alt="example"
                  style={{ width: "100%" }}
                  src={previewImage}
                />
              </Modal>
            </div>
            <p className="prompt">
              支持jpg、png、gif、jpeg格式的图片，每张图片不大于5MB
            </p>
          </div>
          <div className={`${clsPrefix}-item`}>
            <Button
              className="confirm"
              type="primary"
              onClick={this.handleSubmit}
              loading={this.state.loading}
            >
              确定
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
export default AddSignature;
